import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
	arrayOf,
	oneOfType,
	element,
	node
} from 'prop-types';


const ScrollRestoration = ({ children }) => {
	const location = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);

	return children;
};

ScrollRestoration.propTypes = {
	children: oneOfType([element, arrayOf(element), node]).isRequired
};

export default ScrollRestoration;
